export default function secondsToTimeString(v) {
  const hours = Math.floor(v / 3600);
  let minutes = Math.floor((v % 3600) / 60);
  let seconds = (v % 3600) % 60;
  // round to 1000ths
  seconds = Math.round(seconds * 1000) / 1000;
  // pad
  minutes = minutes < 10 && hours > 0 ? `0${minutes}` : minutes;
  seconds = seconds < 10 ? `0${seconds}` : seconds;
  return `${(hours > 0 ? `${hours}:` : '') + minutes}:${seconds}`;
}
